// ============================================================
// BLACK OWL - Notifications toggle (FB-15 phase 1)
// ============================================================

import { useState } from "react";
import { FONT_BODY } from "./theme";
import {
  notificationsSupported, readNotifyPrefs, writeNotifyPrefs, requestNotifyPermission,
} from "./notify";

function Switch({ label, checked, onChange, disabled }) {
  return (
    <label style={{
      display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px",
      fontSize: "13px", fontWeight: 600, color: disabled ? "#5a5a6e" : "#e8e6df",
      fontFamily: FONT_BODY, cursor: disabled ? "default" : "pointer",
    }}>
      {label}
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        style={{ width: "18px", height: "18px", accentColor: "#c9a227", cursor: "inherit" }}
      />
    </label>
  );
}

export default function NotificationsToggle() {
  const supported = notificationsSupported();
  const [prefs, setPrefs] = useState(readNotifyPrefs);
  const [permission, setPermission] = useState(supported ? Notification.permission : "unsupported");

  const update = (next) => { setPrefs(next); writeNotifyPrefs(next); };

  const toggleAlerts = async (on) => {
    if (!on) return update({ ...prefs, enabled: false });
    const result = await requestNotifyPermission();
    setPermission(result);
    update({ ...prefs, enabled: result === "granted" });
  };

  let status;
  if (!supported) status = "This browser can't show notifications. The tab title still flashes when something happens.";
  else if (permission === "denied") status = "Notifications are blocked for this site. Allow them in your browser settings to turn this on.";
  else status = "Alerts for arrows you earn, arrows fired at you, and your draft pick, while Black Owl is open in a tab. They won't reach a locked phone yet.";

  return (
    <div style={{
      width: "100%", maxWidth: "360px", margin: "0 auto 12px",
      padding: "14px 16px", boxSizing: "border-box",
      background: "rgba(255,255,255,0.02)",
      border: "1px solid rgba(255,255,255,0.06)", borderRadius: "10px",
      display: "flex", flexDirection: "column", gap: "10px", textAlign: "left",
    }}>
      <Switch
        label="🔔 Notifications"
        checked={prefs.enabled && permission === "granted"}
        disabled={!supported || permission === "denied"}
        onChange={toggleAlerts}
      />
      <Switch
        label="🔊 Sound"
        checked={prefs.sound}
        onChange={(on) => update({ ...prefs, sound: on })}
      />
      <p style={{ fontSize: "11px", lineHeight: 1.45, color: "#7a7a8e", margin: 0, fontFamily: FONT_BODY }}>
        {status}
      </p>
    </div>
  );
}
